/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
import upload from '@/utils/upload';
import { mapState } from 'vuex';
export default {
  name: 'fileupload',
  props: {
    target: {
      type: String
    },
    action: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      file: null
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user'])),
  mounted: function mounted() {
    if (this.multiple) {
      this.$refs.file.setAttribute('multiple', true);
    }
  },
  methods: {
    emitter: function emitter(event, data) {
      this.$emit(event, data);
    },
    updateProgress: function updateProgress(oEvent) {
      var vm = this;

      if (oEvent.lengthComputable) {
        var percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total);
        vm.emitter('progress', percentComplete);
      } else {
        // Unable to compute progress information since the total size is unknown
        vm.emitter('progress', false);
      }
    },
    onFileChange: function onFileChange(e) {
      var _this = this;

      var vm = this;

      if (!this.target || this.target === '') {
        console.log('Please provide the target url');
      } else if (!this.action || this.action === '') {
        console.log('Please provide file upload action ( POST / PUT )');
      } else if (this.action !== 'POST' && this.action !== 'PUT') {
        console.log('File upload component only allows POST and PUT Actions');
      } else {
        console.log(e);
        var files = e.target.files || e.dataTransfer.files;

        if (!files.length) {
          return;
        }

        if (this.multiple) {
          var uploadList = Array.from(files).map(function (file) {
            return uploadFile.call(_this, file);
          });
          Promise.all(uploadList);
        } else {
          uploadFile.call(this, files[0]);
        } // eslint-disable-next-line


        function uploadFile(file) {
          var _this2 = this;

          return new Promise(function (resolve) {
            upload({
              action: _this2.action,
              target: _this2.target,
              file: file,
              filename: file.name,
              headers: {
                token: _this2.user.csrfToken
              },
              onProgress: vm.updateProgress,
              onStart: function onStart(e) {
                _this2.emitter('start', e);
              },
              onEnd: function onEnd(e) {
                _this2.emitter('finish', e);

                resolve(e);
              }
            });
          });
        }
        /* global FormData XMLHttpRequest:true */

        /* eslint no-undef: "error" */
        // this.file = files[0]
        // let formData = new FormData()
        // formData.append('file', this.file, this.file.name)
        // var xhr = new XMLHttpRequest()
        // xhr.open(this.action, this.target)
        // xhr.onloadstart = function(e) {
        //   vm.emitter('start', e)
        // }
        // xhr.onloadend = function(e) {
        //   vm.emitter('finish', e)
        // }
        // xhr.upload.onprogress = vm.updateProgress
        // xhr.send(formData)

      }
    }
  }
};